import { render } from "./index.vue?vue&type=template&id=698ed202&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=698ed202&lang=scss"
import "./index.vue?vue&type=style&index=1&id=698ed202&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ed202"]])

export default __exports__